import { createFileRoute } from '@tanstack/react-router';
import { TenantNew } from '@/screens/RAdmin/Tenants/TenantNew';

export const Route = createFileRoute('/radiant/tenants/new')({
  component: TenantNew,
});
